import { Modal } from 'react-bootstrap';
import { CloseModalIcon } from '../../icons/icons';
import './SusyModal.css';

export interface SusyModalProps {
    showModal: boolean;
    classes?: string;
    dialogClasses?: string;
    modalBody?: JSX.Element;
    modalFooter?: JSX.Element | null;
    dataTestId?: string;
    title?: string;
    size?: SusyModalSizes;
    notCloseOnOutsideClick?: boolean;
    onHide: () => void;
    subModal?: boolean;
    scrollable?: boolean;
    fullscreen?:
        | true
        | string
        | 'sm-down'
        | 'md-down'
        | 'lg-down'
        | 'xl-down'
        | 'xxl-down';
}

export enum SusyModalSizes {
    SM = 'sm',
    LG = 'lg',
    XL = 'xl',
}

export const SusyModal = (props: SusyModalProps) => {
    const getClassName = () => {
        const classes = ['susy-modal', props.classes ?? ''];
        if (props.size === SusyModalSizes.XL) {
            classes.push('extra-large');
        }
        if (props.subModal) {
            classes.push('sub-modal');
        }
        return classes.join(' ');
    };

    const getModalSize = () => {
        return props.size ?? SusyModalSizes.SM;
    };

    return (
        <Modal
            show={props.showModal}
            onHide={props.onHide}
            backdrop={props.notCloseOnOutsideClick ? 'static' : true}
            data-testid={props.dataTestId}
            size={getModalSize()}
            className={getClassName()}
            backdropClassName={props.subModal ? 'sub-modal-backdrop' : ''}
            fullscreen={props.fullscreen}
            scrollable={props.scrollable}
            dialogClassName={props.dialogClasses}
        >
            <div
                className={
                    'susy-modal-close-btn float-right mt-3 mr-3 cursor-pointer'
                }
                onClick={props.onHide}
            >
                <CloseModalIcon />
            </div>
            {props.title && (
                <Modal.Header className={'susy-modal-header'}>
                    {props.title ? (
                        <h3 className={'susy-modal-title mb-0'}>
                            {props.title}
                        </h3>
                    ) : null}
                </Modal.Header>
            )}

            <Modal.Body className={'susy-modal-body'}>
                {props.modalBody}
            </Modal.Body>
            {props.modalFooter && (
                <Modal.Footer className={'susy-modal-footer'}>
                    {props.modalFooter}
                </Modal.Footer>
            )}
        </Modal>
    );
};
